import { z } from 'zod'
import { OPENING_HOURS_STATUS, RESERVATIONS_TIME_SLOTS, SORTING_OPTION } from './enums'
import { coerceBoolean, coerceNumber, coerceNumberArray, coerceString, coerceStringArray, coerceValidDayjs } from './constraints'

/** Positive 1-based pagination page from URL query (invalid/missing → 1). */
export const paginationPageQuerySchema = z.preprocess(coerceNumber, z.number().int().min(1).default(1).catch(1))

export const myLocationQuerySchema = z.object({
	latMy: z.preprocess(coerceNumber, z.number().optional().catch(undefined)),
	lonMy: z.preprocess(coerceNumber, z.number().optional().catch(undefined))
})

export const homePageQuerySchema = myLocationQuerySchema.extend({})

export const salonPageQuerySchema = z.object({
	// t is query parameter that our BE adds to the URL in the email - it represents token
	t: z.preprocess(coerceString, z.string().optional().catch(undefined)),
	// reservationID is query parameter that our BE adds to the URL in the email
	reservationID: z.preprocess(coerceString, z.guid().optional().catch(undefined)),
	fe_selectedIndustryID: z.preprocess(coerceString, z.guid().optional().catch(undefined)),
	fe_selectedAvResTimeSlotDayPart: z.enum(RESERVATIONS_TIME_SLOTS).optional().catch(undefined),
	fe_selectedAvResTimeSlotDate: z.preprocess((val) => coerceValidDayjs(val), z.string().optional().catch(undefined))
})

export const commonSalonsPageQuerySchema = myLocationQuerySchema.extend({
	hasAvailableReservationSystem: z.preprocess(coerceBoolean, z.boolean().default(true).catch(true)),
	// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
	// hasGift: z.preprocess((val) => coerceBoolean(val) || undefined, z.literal(true).optional().catch(undefined)),
	page: paginationPageQuerySchema,
	openingHoursStatus: z.enum(OPENING_HOURS_STATUS).optional().catch(undefined),
	lat: z.preprocess(coerceNumber, z.number().optional().catch(undefined)),
	lon: z.preprocess(coerceNumber, z.number().optional().catch(undefined)),
	googlePlaceID: z.preprocess(coerceString, z.string().optional().catch(undefined)),
	orderBy: z.enum(SORTING_OPTION).default(SORTING_OPTION.RECOMMENDED).catch(SORTING_OPTION.RECOMMENDED),
	exactRating: z.preprocess(coerceNumberArray, z.array(z.number().int().min(1).max(5)).default([]).catch([])),
	languageIDs: z.preprocess(coerceStringArray, z.array(z.guid()).default([]).catch([])),
	cosmeticIDs: z.preprocess(coerceStringArray, z.array(z.guid()).default([]).catch([])),
	serviceTotalPriceFrom: z.preprocess(coerceNumber, z.number().optional().catch(undefined)),
	serviceTotalPriceTo: z.preprocess(coerceNumber, z.number().optional().catch(undefined)),
	avResTimeSlotDayPart: z.enum(RESERVATIONS_TIME_SLOTS).optional().catch(undefined),
	avResTimeSlotDate: z.preprocess((val) => coerceValidDayjs(val), z.string().optional().catch(undefined)),
	avResTimeSlotDateFrom: z.preprocess((val) => coerceValidDayjs(val), z.string().optional().catch(undefined)),
	avResTimeSlotDateTo: z.preprocess((val) => coerceValidDayjs(val), z.string().optional().catch(undefined)),
	isMapView: z.preprocess(coerceBoolean, z.boolean().optional().catch(undefined))
})

export const salonListPageQuerySchema = commonSalonsPageQuerySchema

export const salonsCategoryPageSchema = commonSalonsPageQuerySchema.extend({
	categoryIDs: z.preprocess(coerceStringArray, z.array(z.guid())).default([]).catch([])
})

export const myReservationPageQuerySchema = z.object({
	/**
	 * t: A query parameter added by the backend to the URL in the email, representing a token.
	 * This token is often duplicated in the URL, so it is processed as an array.
	 */
	t: z.preprocess(coerceStringArray, z.array(z.string()).default([]).catch([]))
})

export const myReservationsPageQuerySchema = z.object({
	pastReservationsPage: paginationPageQuerySchema
})

export const myPassesPageQuerySchema = z.object({
	activePassesPage: paginationPageQuerySchema,
	pastPassesPage: paginationPageQuerySchema
})
